module.exports = __webpack_public_path__ + "media/images/logo_300x100-caa39de093284e27e474db9be44f67b1.png";